class homePage {
   init() {
      console.log('homepage init');

      // var ul = document.querySelector('.products-list');

      // Shuffle function using Fisher-Yates algorithm
      function shuffle(array) {
         for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
         }
         return array;
      }

      $('.product-flip').each(function () {
         var itemsArray = $(this).children().get();
         var shuffledItems = shuffle(itemsArray);

         // limit to 10
         shuffledItems = shuffledItems.slice(0, 10);

         // remove all
         // $(this).empty();

         const par = this;
         // Re-append shuffled items to the list
         shuffledItems.forEach(function (item, idx) {
            setTimeout(function () {
               par.appendChild(item);

               // check if images loaded, then show
               $(item).find('img').on('load', function () {
                  $(this).closest('.collection-card').addClass('loaded');
               }).each(function () {
                  if (this.complete) $(this).trigger('load');
               });
            }, idx * 50);
         });
      });

      $('.home-block .cls').on('click', function (e) {
         e.stopPropagation();
         e.preventDefault();
         let tar = $(this).closest('.home-block');
         tar.toggleClass('out');
         if (tar.hasClass('out')) {
            $(this).text('ⓘ');
            localStorage.setItem('wwwcontemp-info-closed', 'true');
         } else {
            $(this).text('✕');
            localStorage.setItem('wwwcontemp-info-closed', 'false');
         }
      });

      if (localStorage.getItem('wwwcontemp-info-closed')) {
         if (localStorage.getItem('wwwcontemp-info-closed') == 'true') {
            $('.home-block').addClass('out');
            $('.home-block .cls').text('ⓘ');
         } else if (localStorage.getItem('wwwcontemp-info-closed') == 'false') {
            setTimeout(function () {
               $('.home-block').removeClass('out');
               $('.home-block .cls').text('✕');
            }, 1000);
         }
      }

      // $('.home-block').on('click', function(e){
      //    e.stopPropagation();
      //    e.preventDefault();
      //    if($(this).hasClass('out')) {
      //       $(this).removeClass('out');
      //       $(this).find('.cls').text('✕');
      //    }
      // });


      $(window).on('pageshow', function () {
         // $('.collection').addClass('in');
      });

      if (!isTouch) {
         // $('.collection-flip').draggable({
         // });
      }

      const grid = document.querySelector('.featured-collections-row .collections-grid');
      if (grid && grid.children.length && grid.dataset.duped !== '1') {
         // Duplicate children once to enable seamless loop
         const children = Array.from(grid.children);
         children.forEach((child) => {
            const clone = child.cloneNode(true);
            clone.classList.add('is-clone');
            clone.setAttribute('aria-hidden', 'true'); // avoid double announce
            // Prevent keyboard focus on clones but keep them clickable
            clone.querySelectorAll('a, button, [tabindex]')
               .forEach(el => { el.setAttribute('tabindex', '-1'); });
            grid.appendChild(clone);
         });
         grid.dataset.duped = '1';
      }

      // Infinite horizontal loop for Featured Collections Row
      function initFeaturedCollectionsLoop() {
         const grid = document.querySelector('.featured-collections-row .collections-grid');
         if (!grid || grid.dataset.loopInit === '1') return;
         grid.dataset.loopInit = '1';

         // Respect user motion preferences
         if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
         }

         // Bail if there's nothing to scroll
         const duplicationFactor = grid.dataset.duped === '1' ? 2 : 1;
         const originalSetWidth = grid.scrollWidth / duplicationFactor;
         if (originalSetWidth <= grid.clientWidth + 4) {
            return;
         }
         grid.classList.add('looping');
         grid.scrollLeft = 0;

         const speedPxPerSec = 40; // tune speed here
         let paused = false;
         let resumeTimer = null;
         let originalWidth = originalSetWidth; // width of the original set
         let isDragging = false;
         let dragStartX = 0;
         let dragStartScroll = 0;
         let dragMoved = false;
         let preventClick = false;
         let dragDistance = 0;
         let lastPointerX = 0;
         let pointerCaptured = false;
         let baseScrollOffset = 0;
         let loopStart = performance.now();
         let userPaused = false;

         const normalizeOffset = (value) => {
            if (!originalWidth) return 0;
            const mod = value % originalWidth;
            return mod < 0 ? mod + originalWidth : mod;
         };

         const applyScroll = (value) => {
            const normalized = normalizeOffset(value);
            grid.scrollLeft = normalized;
            return normalized;
         };

         const syncBaseToCurrent = () => {
            baseScrollOffset = normalizeOffset(grid.scrollLeft);
         };

         const tick = (now) => {
            if (!paused && !isDragging) {
               const elapsed = now - loopStart;
               const distance = (speedPxPerSec * elapsed) / 1000;
               const target = applyScroll(baseScrollOffset + distance);
               baseScrollOffset = target;
               loopStart = now;
            }
            requestAnimationFrame(tick);
         };

         function pause() {
            syncBaseToCurrent();
            paused = true;
            userPaused = true;
            if (resumeTimer) clearTimeout(resumeTimer);
         }

         function resumeSoon(delay = 1200) {
            if (resumeTimer) clearTimeout(resumeTimer);
            resumeTimer = setTimeout(() => {
               userPaused = false;
               if (originalWidth <= grid.clientWidth + 4) return;
               syncBaseToCurrent();
               paused = false;
               loopStart = performance.now();
            }, delay);
         }

         const pointerDown = (event) => {
            if (!event.isPrimary) return;
            if (event.button !== undefined && event.button !== 0 && event.pointerType !== 'touch') {
               return;
            }
            if (event.target?.closest('.collection-flip__nav')) {
               return;
            }
            pause();
            syncBaseToCurrent();
            isDragging = true;
            dragMoved = false;
            dragStartX = event.clientX;
            dragStartScroll = baseScrollOffset;
            dragDistance = 0;
            lastPointerX = event.clientX;
            grid.classList.add('is-dragging');
            pointerCaptured = false;
         };

         const pointerMove = (event) => {
            if (!isDragging) return;
            pause();
            const delta = event.clientX - dragStartX;
            const step = event.clientX - lastPointerX;
            dragDistance += Math.abs(step);
            lastPointerX = event.clientX;
            if (!dragMoved && dragDistance > 4) {
               dragMoved = true;
               if (!pointerCaptured) {
                  try {
                     grid.setPointerCapture(event.pointerId);
                     pointerCaptured = true;
                  } catch (err) {
                     // ignore
                  }
               }
            }
            if (dragMoved && event.pointerType === 'touch') {
               event.preventDefault();
            }
            applyScroll(dragStartScroll - delta);
         };

         const endDrag = (event) => {
            if (!isDragging) return;
            isDragging = false;
            grid.classList.remove('is-dragging');
            try {
               grid.releasePointerCapture(event.pointerId);
            } catch (err) {
               // ignore
            }
            pointerCaptured = false;
            syncBaseToCurrent();
            loopStart = performance.now();
            if (dragMoved) {
               preventClick = true;
               setTimeout(() => { preventClick = false; }, 200);
            }
         };

         const cancelDrag = (event) => {
            if (!isDragging) return;
            isDragging = false;
            grid.classList.remove('is-dragging');
            try {
               grid.releasePointerCapture(event.pointerId);
            } catch (err) {
               // ignore
            }
            pointerCaptured = false;
            syncBaseToCurrent();
            loopStart = performance.now();
         };

         const clickGuard = (event) => {
            if (preventClick) {
               event.preventDefault();
               event.stopImmediatePropagation();
               preventClick = false;
            }
         };

         grid.addEventListener('pointerdown', pointerDown);
         grid.addEventListener('pointermove', pointerMove);
         grid.addEventListener('pointerup', endDrag);
         grid.addEventListener('pointercancel', cancelDrag);
         window.addEventListener('pointerup', endDrag);
         grid.addEventListener('click', clickGuard, true);
         grid.addEventListener('dragstart', (event) => {
            event.preventDefault();
         });

         grid.addEventListener('mouseenter', () => {
            if (isDragging) return;
            pause();
         });
         grid.addEventListener('mouseleave', () => {
            if (isDragging) return;
            resumeSoon(50);
         });
         grid.addEventListener('wheel', () => { pause(); resumeSoon(1500); }, { passive: true });

         // Recompute original width when content size changes (images load, resize)
         const recalc = () => {
            const width = grid.scrollWidth / (grid.dataset.duped === '1' ? 2 : 1);
            originalWidth = width;
            syncBaseToCurrent();
            applyScroll(baseScrollOffset);
            if (originalWidth <= grid.clientWidth + 4) {
               paused = true;
               return;
            }
            if (!isDragging && !userPaused) {
               paused = false;
               loopStart = performance.now();
            }
         };
         if (window.ResizeObserver) {
            const ro = new ResizeObserver(recalc);
            ro.observe(grid);
         }
         window.addEventListener('resize', recalc);
         window.addEventListener('orientationchange', recalc);

         requestAnimationFrame(tick);
      };

      if (grid) {
         requestAnimationFrame(initFeaturedCollectionsLoop);
      }


      $('.collection-flip').each(function () {
         let l = Math.random() * 5 + 5;
         let r = Math.random() * 5 + 5;
         let t = Math.random() * 10 + 2;
         let b = Math.random() * 8 - 4;
         // if(isTouch) {
         //    b = ;
         // }
         // $(this).css('margin', `${t}rem ${r}% ${b}rem ${l}%`);

         setTimeout(() => {

            const $flip = $(this);
            this.$items = $flip.find('.flip__item');
            this.itemCount = this.$items.length;
            this.currentIndex = 0;

            this.$items.each((i, el) => {
               const randX = (Math.random() * 1) - 0.5;
               const randY = (Math.random() * 1) - 0.5;
               const randRotate = (Math.random() * 10) - 5;
               const offsetTop = (Math.random() * 1) - 0.5;
               const offsetLeft = (Math.random() * 1) - 0.5;
               const $item = $(el);

               $item.css({
                  top: `${offsetTop}rem`,
                  left: `${offsetLeft}rem`,
                  zIndex: i
               });

               $item.css('--flip-translate-x', `${randX}rem`);
               $item.css('--flip-translate-y', `${randY}rem`);
               $item.css('--flip-rand-rotation', `${randRotate}deg`);

               if (i == 0) {
                  $item.addClass('act');
               }
            });

            const par = this;

            if (par.loop) {
               clearInterval(par.loop);
               par.loop = null;
            }
            if (par.resumeTimeout) {
               clearTimeout(par.resumeTimeout);
               par.resumeTimeout = null;
            }

            if (!par.itemCount) return;

            const applyState = () => {
               par.$items.each(function (index) {
                  const $item = $(this);
                  const newIndex = (index - par.currentIndex + par.itemCount) % par.itemCount;
                  const opMinus = newIndex / par.itemCount;
                  const opVal = 1 - (opMinus * 3.33);
                  $item.css({
                     zIndex: par.itemCount - newIndex,
                     opacity: Math.max(0, opVal),
                  });

                  if (newIndex === 0) {
                     $item.addClass('act');
                  } else {
                     $item.removeClass('act');
                  }
               });
            };

            const advance = (delta = 1) => {
               if (!par.itemCount) return;
               par.currentIndex = (par.currentIndex + delta + par.itemCount) % par.itemCount;
               applyState();
            };

            par.intervalDelay = 1800 + Math.random() * 400;

            const clearResume = () => {
               if (par.resumeTimeout) {
                  clearTimeout(par.resumeTimeout);
                  par.resumeTimeout = null;
               }
            };

            const stopLoop = () => {
               if (par.loop) {
                  clearInterval(par.loop);
                  par.loop = null;
               }
            };

            const startLoop = () => {
               stopLoop();
               par.loop = setInterval(() => {
                  advance(1);
               }, par.intervalDelay);
            };

            const pauseLoop = () => {
               stopLoop();
               clearResume();
            };

            const resumeLoop = (delay = par.intervalDelay) => {
               clearResume();
               if (delay <= 0) {
                  startLoop();
                  return;
               }
               par.resumeTimeout = setTimeout(() => {
                  startLoop();
                  par.resumeTimeout = null;
               }, delay);
            };

            par.applyFlipState = applyState;
            par.advanceFlipLoop = advance;
            par.pauseFlipLoop = pauseLoop;
            par.resumeFlipLoop = resumeLoop;

            applyState();
            startLoop();

            $flip.parents('section').css('opacity', 1);

            const hoverTargets = $flip.find('.collection-card__title-link');
            hoverTargets.on('mouseenter focusin', pauseLoop);
            hoverTargets.on('mouseleave focusout', () => resumeLoop());

            const attachNav = (selector, delta) => {
               const btn = par.querySelector(selector);
               if (!btn) return;
               btn.addEventListener('click', (event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  pauseLoop();
                  advance(delta);
                  resumeLoop();
               });
               btn.addEventListener('mouseenter', pauseLoop);
               btn.addEventListener('mouseleave', () => resumeLoop());
               btn.addEventListener('focusin', pauseLoop);
               btn.addEventListener('focusout', () => resumeLoop());
            };

            attachNav('.collection-flip__nav-btn--prev', -1);
            attachNav('.collection-flip__nav-btn--next', 1);

         }, 600); // 500ms because of the delay of shuffle
      });
   }
}

export default homePage;
